import { AccessToken } from '../interfaces/access-token.interface';
import { AuthCookie } from '../interfaces/auth-cookie.interface';
import { IdToken } from '../interfaces/id-token.interface';

export const getCookie = (name: string): string | undefined => {
  const allCookies: string[][] = document.cookie.split(';').map((c) => c.split('='));
  return allCookies.find((c) => c[0].trim() === name)?.[1];
};

export const getAuth = (): AuthCookie | undefined => {
  const cookie = getCookie('AUTH_STROMIFY');
  if (!cookie) {
    return undefined;
  }
  return JSON.parse(decodeURIComponent(cookie));
};

const getJwtPayload = (token: string) => {
  const base64Url = token.split('.')[1]; // payload
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
};

export const getIdTokenPayload = (): IdToken | undefined => {
  const auth = getAuth();
  const idTokenEncoded = auth?.['id_token'];
  if (!idTokenEncoded) {
    return undefined;
  }
  return getJwtPayload(idTokenEncoded);
};

export const getAccessToken = (): string | undefined => {
  const auth = getAuth();
  return auth?.['access_token'];
};

export const getAccessTokenPayload = (): AccessToken | undefined => {
  const accessTokenEncoded = getAccessToken();
  if (!accessTokenEncoded) {
    return undefined;
  }
  return getJwtPayload(accessTokenEncoded);
};
